import type {FormAction, FormType, InputForm, FormValues} from './';

const INPUT_FORM_KEYS = [
	'register',
	'unregister',
	'setError',
	'clearError',
	'setAction',
	'setValue',
	'setChange',
	'updateOptions',
	'errorsRef',
	'valuesRef',
	'validateField',
] as const;

/**
 * Get form items needed to run an input
 * By not passing the whole form object to an input we have much
 * better control over inputs rendering (and better performance)
 * The methods used are wrapped in useCallback
 * @deprecated
 */
export const getInputFormObject = <
	TValues extends FormValues = FormValues,
	TAction extends FormAction = FormAction,
>(
	form: FormType<TValues, TAction>,
): InputForm<TValues, TAction> => {
	return Object.fromEntries(
		Object.entries(form).filter(([key]) =>
			INPUT_FORM_KEYS.includes(key as any),
		),
	) as InputForm<TValues, TAction>;
};
